export enum ProgressSize {
  XSMALL = 'xsmall',
  SMALL = 'small',
  LARGE = 'large',
  XLARGE = 'xlarge',
  XXLARGE = 'xxlarge',
}

export enum ProgressOrientation {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export enum ProgressColor {
  DEFAULT = 'default',
  DEFAULT_LIGHT = 'default-light',
  SUCCESS = 'success',
  PINK = 'pink',
  YELLOW = 'yellow',
  ORANGE = 'orange',
  RED = 'red',
}

export enum ProgressBackground {
  DEFAULT = 'default',
  DARK = 'dark',
}

export interface ProgressColorMap {
  solid: string;
  gradientStart: string;
  gradientEnd: string;
  secondaryGradientStart?: string;
  secondaryGradientEnd?: string;
}

export interface ProgressMilestone {
  text: string;
  progress: number;
}
